// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Legend swatches take the shared chart palette by series index, so they match
 * the Facebook and Instagram reports without inline styles. */
.social-report__swatch--palette-0 {
  background-color: #2b74e4;
}

.social-report__legend-swatch--palette-0 {
  --legend-color: #2b74e4;
}

.social-report__swatch--palette-1 {
  background-color: #94d0b5;
}

.social-report__legend-swatch--palette-1 {
  --legend-color: #94d0b5;
}

.social-report__swatch--palette-2 {
  background-color: #f6c15f;
}

.social-report__legend-swatch--palette-2 {
  --legend-color: #f6c15f;
}

.social-report__swatch--palette-3 {
  background-color: #8d4fd3;
}

.social-report__legend-swatch--palette-3 {
  --legend-color: #8d4fd3;
}

.social-report__swatch--palette-4 {
  background-color: #5d97ee;
}

.social-report__legend-swatch--palette-4 {
  --legend-color: #5d97ee;
}

.social-report__swatch--palette-5 {
  background-color: #5abf8b;
}

.social-report__legend-swatch--palette-5 {
  --legend-color: #5abf8b;
}

.social-report__swatch--palette-6 {
  background-color: #f0a84a;
}

.social-report__legend-swatch--palette-6 {
  --legend-color: #f0a84a;
}

.social-report__swatch--palette-7 {
  background-color: #b07ae9;
}

.social-report__legend-swatch--palette-7 {
  --legend-color: #b07ae9;
}

/* The TikTok and Snapchat fallback logos are badges, not photos: contain them
 * inside the 38px frame instead of cropping like a post thumbnail would. */
.organic-post-details--modern .organic-post-details__thumb img.organic-post-details__thumb-fallback--tiktok,
.organic-post-details--modern .organic-post-details__thumb img.organic-post-details__thumb-fallback--snapchat {
  object-fit: contain;
  padding: 6px;
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/organicMedia/components/Tabs/socialReport/SocialContentFollowersReport.scss"],"names":[],"mappings":"AAAA;8DAAA;AAOE;EACE,yBANoB;AAExB;;AAOE;EACE,uBAAA;AAJJ;;AADE;EACE,yBANoB;AAUxB;;AADE;EACE,uBAAA;AAIJ;;AATE;EACE,yBANoB;AAkBxB;;AATE;EACE,uBAAA;AAYJ;;AAjBE;EACE,yBANoB;AA0BxB;;AAjBE;EACE,uBAAA;AAoBJ;;AAzBE;EACE,yBANoB;AAkCxB;;AAzBE;EACE,uBAAA;AA4BJ;;AAjCE;EACE,yBANoB;AA0CxB;;AAjCE;EACE,uBAAA;AAoCJ;;AAzCE;EACE,yBANoB;AAkDxB;;AAzCE;EACE,uBAAA;AA4CJ;;AAjDE;EACE,yBANoB;AA0DxB;;AAjDE;EACE,uBAAA;AAoDJ;;AAhDA;2EAAA;AAEA;;EAME,mBAAA;EACA,YAAA;EACA,mBAAA;AA+CF","sourcesContent":["/* Legend swatches take the shared chart palette by series index, so they match\n * the Facebook and Instagram reports without inline styles. */\n$social-report-palette: (#2b74e4, #94d0b5, #f6c15f, #8d4fd3, #5d97ee, #5abf8b, #f0a84a, #b07ae9);\n\n@each $color in $social-report-palette {\n  $index: index($social-report-palette, $color) - 1;\n\n  .social-report__swatch--palette-#{$index} {\n    background-color: $color;\n  }\n\n  .social-report__legend-swatch--palette-#{$index} {\n    --legend-color: #{$color};\n  }\n}\n\n/* The TikTok and Snapchat fallback logos are badges, not photos: contain them\n * inside the 38px frame instead of cropping like a post thumbnail would. */\n.organic-post-details--modern\n  .organic-post-details__thumb\n  img.organic-post-details__thumb-fallback--tiktok,\n.organic-post-details--modern\n  .organic-post-details__thumb\n  img.organic-post-details__thumb-fallback--snapchat {\n  object-fit: contain;\n  padding: 6px;\n  background: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
